module.exports = __webpack_public_path__ + "img/HiwaQader-MaliPshilakan.401aa2b9.jpg";